module.exports = __webpack_public_path__ + "img/barbequed-vegetables.968fd99e.jpg";